import axios from "axios";
const API_URL = process.env.REACT_APP_AUTH_URL || "http://localhost:8080/api/auth";

const login = (email, password) => {
  return axios
    .post(API_URL + "/signin", { email, password })
    .then((response) => {
      if (response.data.accessToken) {
        // Store user data and JWT in local storage
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const forgotPassword = (email) => {
  return axios.post(API_URL + "/forgot-password", { email });
};

const resetPassword = (token, newPassword) => {
  return axios.post(API_URL + "/reset-password", { token, newPassword });
};

const changePassword = (currentPassword, newPassword) => {
  const user = getCurrentUser();
  return axios.post(
    API_URL + "/change-password",
    { currentPassword, newPassword },
    {
      headers: {
        'x-access-token': user.accessToken
      }
    }
  );
};

const authService = {
  login,
  logout,
  getCurrentUser,
  forgotPassword,
  resetPassword,
  changePassword,
};

export default authService;